import React from "react";
import { TableRow, TableCell } from "@mui/material";
import EzControlledCheckBoxWithLabel from "../../../../../common/EzForm/EzControlledCheckBox/WithLabel";
import "../style.css";

const RoleAccessRow = React.memo(({ module, control, errors, handleChange }) => {
  return (
    <>
      <TableRow className="module-row">
        <TableCell className="table-cell module-name-cell">
          {module.title}
        </TableCell>
        <TableCell className="table-cell permission-cell">
          <EzControlledCheckBoxWithLabel
            name={`${module.menuId}_view`}
            value={module.view}
            control={control}
            isError={errors[`${module.menuId}_view`]}
            labelClassName={"mr-2"}
            onChange={(e) =>
              handleChange(module.menuId, "view", e.target.checked)
            }
          />
        </TableCell>
        <TableCell className="table-cell permission-cell">
          <EzControlledCheckBoxWithLabel
            name={`${module.menuId}_createCrud`}
            value={module.createCrud}
            control={control}
            isError={errors[`${module.menuId}_createCrud`]}
            labelClassName={"mr-2"}
            onChange={(e) =>
              handleChange(module.menuId, "createCrud", e.target.checked)
            }
          />
        </TableCell>
        <TableCell className="table-cell permission-cell">
          <EzControlledCheckBoxWithLabel
            name={`${module.menuId}_editCrud`}
            value={module.editCrud}
            control={control}
            isError={errors[`${module.menuId}_editCrud`]}
            labelClassName={"mr-2"}
            onChange={(e) =>
              handleChange(module.menuId, "editCrud", e.target.checked)
            }
          />
        </TableCell>
        <TableCell className="table-cell delete-permission-cell">
          <EzControlledCheckBoxWithLabel
            name={`${module.menuId}_canDelete`}
            value={module.canDelete}
            control={control}
            isError={errors[`${module.menuId}_canDelete`]}
            labelClassName={"mr-2"}
            onChange={(e) =>
              handleChange(module.menuId, "canDelete", e.target.checked)
            }
          />
        </TableCell>
      </TableRow>
      {module?.accessDTOList?.map((child) => (
        <React.Fragment key={child.menuId}>
          <TableRow
            sx={
              child?.accessDTOList?.length > 0
                ? { backgroundColor: "#fff2d6" }
                : {}
            }
          >
            <TableCell className="table-cell module-name-cell">
              {child.title}
            </TableCell>
            <TableCell className="table-cell permission-cell">
              <EzControlledCheckBoxWithLabel
                name={`${child.menuId}_view`}
                value={child.view}
                control={control}
                isError={errors[`${child.menuId}_view`]}
                labelClassName={"mr-2"}
                onChange={(e) =>
                  handleChange(child.menuId, "view", e.target.checked)
                }
              />
            </TableCell>
            <TableCell className="table-cell permission-cell">
              <EzControlledCheckBoxWithLabel
                name={`${child.menuId}_createCrud`}
                value={child.createCrud}
                control={control}
                isError={errors[`${child.menuId}_createCrud`]}
                labelClassName={"mr-2"}
                onChange={(e) =>
                  handleChange(child.menuId, "createCrud", e.target.checked)
                }
              />
            </TableCell>
            <TableCell className="table-cell permission-cell">
              <EzControlledCheckBoxWithLabel
                name={`${child.menuId}_editCrud`}
                value={child.editCrud}
                control={control}
                isError={errors[`${child.menuId}_editCrud`]}
                labelClassName={"mr-2"}
                onChange={(e) =>
                  handleChange(child.menuId, "editCrud", e.target.checked)
                }
              />
            </TableCell>
            <TableCell className="table-cell delete-permission-cell">
              <EzControlledCheckBoxWithLabel
                name={`${child.menuId}_canDelete`}
                value={child.canDelete}
                control={control}
                isError={errors[`${child.menuId}_canDelete`]}
                labelClassName={"mr-2"}
                onChange={(e) =>
                  handleChange(child.menuId, "canDelete", e.target.checked)
                }
              />
            </TableCell>
          </TableRow>
          {child?.accessDTOList?.map((sub) => (
            <TableRow key={sub.menuId}>
              <TableCell className="table-cell submodule-title-cell">
                {sub.title}
              </TableCell>
              <TableCell className="table-cell permission-cell">
                <EzControlledCheckBoxWithLabel
                  name={`${sub.menuId}_view`}
                  value={sub.view}
                  control={control}
                  isError={errors[`${sub.menuId}_view`]}
                  labelClassName={"mr-2"}
                  onChange={(e) =>
                    handleChange(sub.menuId, "view", e.target.checked)
                  }
                />
              </TableCell>
              <TableCell className="table-cell permission-cell">
                <EzControlledCheckBoxWithLabel
                  name={`${sub.menuId}_createCrud`}
                  value={sub.createCrud}
                  control={control}
                  isError={errors[`${sub.menuId}_createCrud`]}
                  labelClassName={"mr-2"}
                  onChange={(e) =>
                    handleChange(sub.menuId, "createCrud", e.target.checked)
                  }
                />
              </TableCell>
              <TableCell className="table-cell permission-cell">
                <EzControlledCheckBoxWithLabel
                  name={`${sub.menuId}_editCrud`}
                  value={sub.editCrud}
                  control={control}
                  isError={errors[`${sub.menuId}_editCrud`]}
                  labelClassName={"mr-2"}
                  onChange={(e) =>
                    handleChange(sub.menuId, "editCrud", e.target.checked)
                  }
                />
              </TableCell>
              <TableCell className="table-cell delete-permission-cell">
                <EzControlledCheckBoxWithLabel
                  name={`${sub.menuId}_canDelete`}
                  value={sub.canDelete}
                  control={control}
                  isError={errors[`${sub.menuId}_canDelete`]}
                  labelClassName={"mr-2"}
                  onChange={(e) =>
                    handleChange(sub.menuId, "canDelete", e.target.checked)
                  }
                />
              </TableCell>
            </TableRow>
          ))}
        </React.Fragment>
      ))}
    </>
  );
});

export default RoleAccessRow;
